<template>
  <div>
    <el-table
      :data="data"
      stripe
      :row-class-name="tableRowClassName"
      @cell-click="cellClick"
      max-height="650"
      :empty-text="$t('general_noData')"
      style="width: 100%"
      size="small">
      <el-table-column
        prop="transactionDate"
        sortable
        :label="$t('settings_accountThink_GLAccounts_generallEdgerDetailed_date')">
      </el-table-column>
      <el-table-column
        sortable
        :label="$t('settings_accountThink_GLAccounts_generallEdgerDetailed_refNo')">
        <template slot-scope="scope">
          <strong @click="cellClickID(scope.row)" style="color: #409EFF; cursor: pointer;">{{scope.row.transactionNo}}</strong>
        </template>
      </el-table-column>
      <el-table-column
        prop="transactionType"
        :label="$t('settings_accountThink_GLAccounts_generallEdgerDetailed_type')">
      </el-table-column>
      <el-table-column
        prop="transactionDescription"
        align="center"
        :label="$t('settings_accountThink_GLAccounts_generallEdgerDetailed_description')">
        <template slot-scope="scope">
          <el-popover
            v-if="scope.row.transactionDescription"
            placement="top"
            title="Description"
            width="400"
            trigger="click"
            :content="scope.row.transactionDescription">
            <el-button size="mini" slot="reference" icon="el-icon-view"></el-button>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        sortable
        align="center"
        :label="$t('settings_accountThink_GLAccounts_generallEdgerDetailed_status')">
      </el-table-column>
      <el-table-column
        header-align="right"
        sortable
        :label="$t('settings_accountThink_GLAccounts_generallEdgerDetailed_amount')">
        <template slot-scope="scope">
          <div style="text-align: right;">{{formatPrice(scope.row.amount)}}</div>
        </template>
      </el-table-column>
      <!-- <el-table-column
        header-align="right"
        :label="$t('settings_accountThink_GLAccounts_generallEdgerDetailed_debit')">
        <template slot-scope="scope">
          <div v-if="!scope.row.total" style="text-align: right;">{{formatPrice(scope.row.debit)}}</div>
          <div v-else style="text-align: right; color: #2b78e4;">{{formatPrice(scope.row.debit)}}</div>
        </template>
      </el-table-column>
      <el-table-column
        header-align="right"
        :label="$t('settings_accountThink_GLAccounts_generallEdgerDetailed_credit')">
        <template slot-scope="scope">
          <div v-if="!scope.row.total" style="text-align: right;">{{formatPrice(scope.row.credit)}}</div>
          <div v-else style="text-align: right; color: #2b78e4;">{{formatPrice(scope.row.credit)}}</div>
        </template>
      </el-table-column> -->
      <el-table-column
        header-align="right"
        sortable
        :label="$t('settings_accountThink_GLAccounts_generallEdgerDetailed_taxAmount')">
        <template slot-scope="scope">
          <div style="text-align: right;">{{formatPrice(scope.row.taxamount)}}</div>
        </template>
      </el-table-column>
    </el-table>

    <!--Journal Entry modal edit-->
    <editJournalEntryModal @updateList="getList" :tab="'salesReturns'" ref="editJournalEntryModal"/>

  </div>
</template>

<script>
import { Money, VMoney } from 'v-money'
import axios from 'axios'
import moment from 'moment'
import editJournalEntryModal from '@/components/journalAndGl/editJournalEntryModal.vue'
export default {
  name: "salesReturn",
  props: {
    transactionId: {
      default: null
    }
  },
  components: {
    Money,
    editJournalEntryModal,
  },
  directives: {money: VMoney},
  data() {
    return {
      moment: moment,
      data: [],

      page: 1,
      total: 0,
    }
  },
  methods: {
    formatPrice(value) {
      let val = (value/1).toFixed(2).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    openModal() {
      this.item()
    },
    tableRowClassName({row, rowIndex}) {
      return 'cursor-pointer';
    },
    item(filterBy = null, filterValue = null) {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.get(`/api/v1/account/company-ledger/list?transactionCode=SALESRETURN&transactionType=null&companyId=${this.$route.query.companyId}&filterBy=${filterBy}&filterValue=${filterValue}`)
          .then(response => {
            this.data = response.data.list
            this.data.forEach((item) => {
              item.transactionDate = item.transactionDate ? moment(item.transactionDate).format("D MMM YYYY") : ''
              item.amount = (+item.debit + +item.credit) / 2
            })
            if (this.transactionId) {
              const row = this.data.find(val => val.id == this.transactionId)
              if (row) this.cellClickID(row)
              this.$emit('resetTransition')
            }
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
    },
    handleCurrentChange(val) {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.get(`/api/v1/account/general-ledger?accountId=null&companyId=${this.$route.query.companyId}&page=${val}`)
          .then(response => {
            window.scrollTo(0,0)
            // eslint-disable-next-line no-console
            console.log('RERERERE', response.data.item)
            this.data = response.data.item.list
            for (let i = 0; i < this.data.length; i++) {
              this.data[i].transactionDate = this.data[i].transactionDate ? moment(this.data[i].transactionDate).format("D MMM YYYY") : '';
            }
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
    },
    getList() {
      this.item()
    },
    cellClick(row, column, cell, event){
      // if (column.label != "Operations") {
      //   this.$refs['editJournalEntryModal'].openModalFromJournalEntry(row)
      // }
    },
    cellClickID(row){
      this.$refs['editJournalEntryModal'].openModalFromJournalEntry(row)
    },
  },
}
</script>

<style lang="scss" scoped>
.sweet-modal-overlay{
  z-index:1000;
}
</style>
